<template>
  <div>
    <h2 style="margin-top:0rem;">Kopiowanie danych</h2>
    <v-form ref="form">
      <v-select v-model="targetSchemaId" :items="schemas" item-text="name"
                item-value="id" label="Schemat docelowy" @change="getTargetSchema($event)"></v-select>
      <v-container>
        <div v-for="(field) in fields" :key="field.id">
          <v-select v-model="map[field.id]" :items="getTargetFieldsForField(field)" :label="field.name" item-text="name"
                    return-object></v-select>
        </div>
      </v-container>
      <v-checkbox v-model="conditions" label="Warunki"></v-checkbox>
      <div v-if="conditions">
        <v-text-field v-model="afterId" data-vv-name="name" label="Dodaj rekordy większe lub równe od id" required
                      type="number"></v-text-field>
        <v-text-field v-model="beforeId" label="Dodaj rekordy mniejsze lub równe od id" required
                      type="number"></v-text-field>
      </div>
      <v-btn @click="submit()">Ok</v-btn>
    </v-form>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"

export default {
  data() {
    return {
      conditions: false,
      afterId: 0,
      beforeId: 0,
      map: {},
      tab: 0,
      targetSchema: {},
      targetSchemaId: 0,
      schema: {},
      model: {},
      schemaFields: [],
      schemas: [],
    }
  },
  computed: {
    fields() {
      return this.flatFields(this.schemaFields)
    }
  },
  created() {
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let schemas = this.$http.get('schemas')

    Promise.all([schema, schemas]).then((data) => {
      this.schemaFields = data[0].data.fields
      this.schema = data[0].data
      this.schemas = data[1].data.reverse()
    }).catch(() => {
      this.$route.push({
        name: "not-found"
      })
    })
  },
  methods: {
    getTargetFieldsForField(field) {
      if (this.targetSchema == null || this.targetSchema.fields == null) {
        return []
      }

      let fields = this.flatFields(this.targetSchema.fields)

      if (field.parent_order != null) {
        fields = fields.filter(f => f.parent_order != null)

        let anotherFieldTabelAlreadySigned = this.fields.filter(el => el.parent_order == field.parent_order)
            .find(el => this.map[el.id] != null && el.id != field.id)

        if (anotherFieldTabelAlreadySigned != null) {
          fields = fields.filter(f => f.parent_order == this.map[anotherFieldTabelAlreadySigned.id].parent_order)
        }
      } else {
        fields = fields.filter(f => f.parent_order == null)
      }

      // Object.keys(this.map).forEach((key) => {
      //   fields = (this.map[key] != null && key != field.id ) ? fields.filter(f => f.id != this.map[key].id) : fields
      // });

      return fields
    },
    flatFields(schemaFields) {
      let fields = []
      schemaFields.forEach(field => {
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => {
            subField.parent_order = field.order
            subField.parent_id = field.id
            subField.is_sub_field = true
            fields.push(subField)
          })
        } else {
          field.is_sub_field = false
          fields.push(field)
        }
      })
      return fields
    },
    getTargetSchema(id) {
      this.$http.get('schema/' + id).then(data => {
        this.targetSchema = data.data
      }).catch(() => Messenger.emitError("Error"))
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.$confirm("Jesteś pewien, że chcesz rozpocząć kopiowanie?").then((res) => {
        if (!res) {
          return
        }

        let postData = this.createPostData()
        this.$http.post(`form/${this.schema.id}/copy-data`, postData).then(() => {
          this.$store.commit('setSnack', {
            message: "Kopiowanie zakończone",
            color: 'success'
          })
          this.$router.push('/form/' + postData.target_schema_id)
        }).catch(() => {
          this.$store.commit('setSnack', {
            message: "Wystąpił problem przy kopiowaniu",
            color: 'error'
          })
        })
      })
    },
    createPostData() {
      let data = {}
      data.target_schema_id = Number(this.targetSchemaId)
      data.base_schema_id = Number(this.$route.params.schemaId)
      data.after_id = this.conditions ? Number(this.afterId) : 0
      data.before_id = this.conditions ? Number(this.beforeId) : 0
      data.map = []

      Object.keys(this.map).forEach((key) => {
        data.map.push({
          base: this.fields.find(el => el.id == key),
          target: this.map[key]
        })
      })

      return data
    }
  },
}
</script>
